import React from "react";
import { WelcomeSection } from "../WelcomeSection";
import { FormDescription } from "../FormDescription";
import { Check } from "lucide-react";

interface SuccessPageProps {
  activeStep: number;
  totalSteps: number;
}

export const SuccessPage: React.FC<SuccessPageProps> = ({}) => {
  return (
    <div className="flex overflow-y-auto gap-4 sm:gap-10 z-0 grow flex-col p-5 sm:px-10 sm:pt-6 rounded-xl shadow-lg bg-background/10 w-full sm:max-w-[700px] sm:h-auto sm:flex-1">
      <div className="flex flex-col items-center justify-center h-full gap-8">
        <div className="flex items-center justify-center w-24 h-24 rounded-full bg-green-500/20">
          <Check className="w-12 h-12 text-green-500" />
        </div>

        <WelcomeSection
          title="Formulário enviado com sucesso!"
          subtitle="Agradecemos pelo seu tempo"
          description="Seus dados foram recebidos e serão analisados pela nossa equipe."
        />

        <FormDescription
          title="Próximos passos"
          text="Nossa equipe entrará em contato em breve para dar continuidade ao processo. Fique atento ao seu e-mail e telefone cadastrados."
        />
      </div>
    </div>
  );
};
